import React from 'react';

import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';
import _ from 'es-toolkit/compat';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router';

type LinkProps = MuiLinkProps<typeof RouterLink, RouterLinkProps>;

export const Link: React.FC<React.PropsWithChildren<LinkProps>> = ({ children, ...props }) => {
  const linkProps = React.useMemo(() => {
    if (_.isString(props.to) && props.to.startsWith('http')) {
      return {
        ...props,
        target: 'blank',
      };
    }
    return props;
  }, [props]);

  return (
    <MuiLink component={RouterLink} {...linkProps}>
      {children}
    </MuiLink>
  );
};
